import { render, staticRenderFns } from "./TablaTarjetasRegalo.vue?vue&type=template&id=c1698e42&scoped=true&"
import script from "./TablaTarjetasRegalo.vue?vue&type=script&lang=js&"
export * from "./TablaTarjetasRegalo.vue?vue&type=script&lang=js&"
import style0 from "./TablaTarjetasRegalo.vue?vue&type=style&index=0&id=c1698e42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1698e42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VDivider,VIcon,VList,VListItem,VListItemTitle,VMenu,VTooltip})
